import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { JobActionResponseMessage } from '../../model/job.model'

@Component({
  selector: 'hs-action-error-modal',
  templateUrl: './action-error-modal.component.html',
})
export class ActionErrorModalComponent {
  @Input() type: 'cancel' | 'resubmit' = 'cancel'
  @Input() messageMap: JobActionResponseMessage = {}

  constructor(public activeModal: NgbActiveModal) {}
}
